export const formatPaise = (paise) =>
  `₹${((paise || 0) / 100).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`;

export const rupeesToPaise = (rupees) => Math.round(Number(rupees || 0) * 100);

export const formatBillingDate = (date) => {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("en-IN", { year: "numeric", month: "short", day: "numeric" });
};

export const getSubscriptionGraceInfo = (subscription) => {
  if (!subscription) return null;
  const now = new Date();
  const endDate = new Date(subscription.endDate);
  const isExpired = subscription.status === "EXPIRED" || endDate < now;

  if (subscription.type === "TRIAL") {
    return {
      state: isExpired ? "TRIAL_EXPIRED" : "TRIAL",
      label: isExpired ? "Trial Expired" : "Trial",
      variant: isExpired ? "destructive" : "secondary",
      badgeClass: isExpired ? "bg-red-500 text-white" : "bg-blue-600 text-white hover:bg-blue-600",
    };
  }

  if (!isExpired && subscription.status === "ACTIVE") {
    return {
      state: "ACTIVE",
      label: "Active",
      variant: "default",
      badgeClass: "bg-green-600 text-white hover:bg-green-600",
    };
  }

  const graceDays = subscription.gracePeriodDays ?? 15;
  const graceEnd = new Date(endDate.getTime() + graceDays * 24 * 60 * 60 * 1000);

  if (now <= graceEnd) {
    const msLeft = graceEnd.getTime() - now.getTime();
    const daysLeft = Math.max(1, Math.ceil(msLeft / (1000 * 60 * 60 * 24)));
    return {
      state: "IN_GRACE",
      label: `In Grace Period (${daysLeft}d left)`,
      daysLeft,
      graceDays,
      variant: "secondary",
      badgeClass: "bg-amber-500 text-white hover:bg-amber-500",
    };
  }

  return {
    state: "GRACE_EXPIRED",
    label: "Grace Expired",
    graceDays,
    variant: "destructive",
    badgeClass: "bg-red-600 text-white hover:bg-red-600",
  };
};
